module.exports = __webpack_public_path__ + "img/fire.e36fcb42.gif";